import { type Auth0PageViewUrlParams } from '../../../../lib/auth0/types';
import { type SegmentAbstraction } from '../../../../lib/analytics/Segment';
import { auth0 } from '../../../../lib/auth0';
import { getDeviceId } from '../../../../lib/auth0/utils';
import { env } from '../../../../lib/env';

export async function getAuthUrls(
  analytics?: SegmentAbstraction,
  pageView?: Auth0PageViewUrlParams,
) {
  const anonymousUserId = (await analytics?.segmentInstance?.user())?.anonymousId() ?? 'unknown';

  const currentURL = new URL(window.location.href);
  const urlWithoutSearchParams = `${currentURL.origin}${currentURL.pathname}`;
  const bypassMFA =
    env.NEXT_PUBLIC_DEPLOYABLE_ENV !== 'prod' &&
    currentURL.searchParams.get('feat_bypass_mfa') === 'true';

  const authLinkSharedParams = {
    anonymousUserId,
    driverElement: 'button',
    driverLocation: 'global_nav_reg_cta_v1',
    driverSubLocation: 'global_nav_reg_cta_v1',
    driverPageUrl: urlWithoutSearchParams,
    redirectTo: window.location.href,
    mostRecentTraditionalDeviceId: getDeviceId(),
    ...(bypassMFA && { bypassMFA: true }),
    ...pageView,
  };

  const newSignUpUrl = auth0.generateAuthLink({
    initialScreen: 'signup',
    ...authLinkSharedParams,
  });

  const newSignInUrl = auth0.generateAuthLink({
    initialScreen: 'signin',
    ...authLinkSharedParams,
  });

  return { newSignUpUrl, newSignInUrl };
}
